import { lookupSelector } from '~store/lookupSelector';
import { selectors as ModalSelectors } from '~store/slices/modal';
import { selectRootState } from './root';

// Root: Slice Selectors
export const selectModalState = lookupSelector(selectRootState, state => state.modal);

// Slice: Modal Selectors
export const selectModal = lookupSelector(selectModalState, ModalSelectors.modal);
